/** Coerce any API / Stripe / thrown value into a string safe for React text and Error().message */
export function toSafeAlertString(value: unknown, fallback = ''): string {
  if (value == null || value === '') return fallback;
  if (typeof value === 'string') {
    const t = value.trim();
    return t || fallback;
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  if (value instanceof Error) {
    const t = value.message?.trim?.() ?? '';
    return t || fallback;
  }
  if (typeof value === 'object') {
    const o = value as Record<string, unknown>;
    const m = o.message;
    if (typeof m === 'string' && m.trim()) return m.trim();
    if (typeof m === 'number' || typeof m === 'boolean') return String(m);
    try {
      const s = JSON.stringify(value);
      if (s && s !== '{}') return s.length > 400 ? `${s.slice(0, 400)}…` : s;
    } catch {
      /* ignore */
    }
  }
  return fallback;
}
